/** Matches {@link getMasterDataUpdate} GET abort timeout. */
export const SYNC_CATALOG_GET_TIMEOUT_MS = 120_000;

/** Startup orchestrator cap for catalog download (aligned with GET transport timeout). */
export const SYNC_CATALOG_STARTUP_DOWNLOAD_TIMEOUT_MS = SYNC_CATALOG_GET_TIMEOUT_MS;

/** Same cap after snapshot-revision upgrade (large first apply). */
export const SYNC_CATALOG_STARTUP_DOWNLOAD_TIMEOUT_AFTER_REVISION_MS = SYNC_CATALOG_GET_TIMEOUT_MS;

/** Post-auth catalog retry overlay uses the same download budget. */
export const SYNC_CATALOG_POST_AUTH_DOWNLOAD_TIMEOUT_MS = SYNC_CATALOG_GET_TIMEOUT_MS;
